import { render, staticRenderFns } from "./newWomen.vue?vue&type=template&id=19fcd8cc&"
import script from "./newWomen.vue?vue&type=script&lang=js&"
export * from "./newWomen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports